<template>
  <div class="loadingBanner"
    element-loading-text="资源加载中，请稍后。">
    <img src="../../assets/images/banner.jpg" alt="">
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>
// PC端样式
@media only screen and (min-width: 1024px) {
  .loadingBanner{
    height: 100vh;
    width: 100%;
    background: #f2f2f2;
    overflow: hidden;
    position: relative;
    img{
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      min-width: 100%;
      min-height: 100vh;
      transform: translate(-50%,-50%);
    }
  }
}
// 移动端样式
@media only screen and (max-width: 1024px) {
}

</style>



// WEBPACK FOOTER //
// src/components/comForPc/loading_banner.vue